<template>
  <span v-show="shopStore.cartItemCount > 0" class="cart-number">{{
    shopStore.cartItemCount
  }}</span>
</template>

<script setup lang="ts">
import { useShopStore } from '@/stores/shop.ts'
import { onBeforeMount } from 'vue'

/** PROPS */
const props = withDefaults(
  defineProps<{
    initCartItemCount?: number
  }>(),
  {
    initCartItemCount: 0,
  },
)

/** STATE */
const shopStore = useShopStore()

/** LIFECYCLE */
onBeforeMount(() => {
  shopStore.setCartItemCount(props.initCartItemCount)
})

/** METHODS */
</script>
